import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import MaterialTable from '../../Components/Table/MaterialTable'
import { FaSearch } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom'
import { tableEye } from '../../common/Assets/imgs'
import { get } from '../../Services/ApiHandler'
import { URLS } from '../../Services/Constant'

const Transaction = () => {
  const navigation = useNavigate();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("pending")
  const [adminList, setAdminList] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [loader, setLoader] = useState(false);
  const pendingData = [
    {
      sno: "01",
      transportId: "KD075821",
      transportName: "Swift way Transports",
      amount: "₹35500",
    },
    {
      sno: "02",
      transportId: "KD075822",
      transportName: "Blue Route Logistics",
      amount: "₹65550",
    },
    {
      sno: "03",
      transportId: "KD075823",
      transportName: "Khyathi Movers",
      amount: "₹87550",
    },
  ];

  const completedData = [
    {
      sno: "01",
      transactionName: "Khyathi Logistics",
      transportName: "Swift way Transports",
      amount: "₹35500",
      dateTime: "10-12-2025, 1:00 PM",
    },
    {
      sno: "02",
      transactionName: "Khyathi Logistics",
      transportName: "Blue Route Logistics",
      amount: "₹65550",
      dateTime: "10-12-2025, 1:00 PM",
    },
    {
      sno: "03",
      transactionName: "Khyathi Logistics",
      transportName: "Khyathi Movers",
      amount: "₹87550",
      dateTime: "10-12-2025, 1:00 PM",
    },
  ];
  const pageSize = 10;
  const pendingColumns = [
    {
      header: "S.No",
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      // accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    { accessorKey: "transport_code", header: "Transport ID" },
    { accessorKey: "transport_name", header: "Transport Name" },
    {
      accessorKey: "total_amount",
      header: "Amount",
      Cell: ({ cell }) => (
        <span style={{ color: "green", fontWeight: 600 }}>
          {cell.getValue()}
        </span>
      ),
    },
    {
      id: "action",
      header: "Action",
      Cell: ({ row }) => (
        <div onClick={() => {
          navigation("/transaction-view", {
            state: {
              rowData: row.original,
              id: row.original.transport_id,
              type: "view",
              status: "pending"
            },
          });
        }
        }>
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  const formatDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 → 12

    return `${day}-${month}-${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  };

  const completedColumns = [
    {
      header: "S.No",
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      // accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    { accessorKey: "transaction_name", header: "Transaction Name" },
    { accessorKey: "transport_name", header: "Transport Name" },
    {
      accessorKey: "total_amount",
      header: "Amount",
      Cell: ({ cell }) => (
        <span style={{ color: "green", fontWeight: 600 }}>
          {cell.getValue()}
        </span>
      ),
    },
    {
      accessorKey: "created_at", header: "Date & Time",
      Cell: ({ cell }) => (
        <span
        // style={{ color: "green", fontWeight: 600 }}
        >
          {formatDate(cell.getValue())}
        </span>
      ),
    },

    {
      id: "action",
      header: "Action",
      Cell: ({ row }) => (
        <div onClick={() => {
          navigation("/transaction-view", {
            state: {
              rowData: row.original,
              id: row.original.transport_id,
              type: "view",
              status: "completed"
            }
          })
        }
        }>
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  // const tableData = status === "pending" ? pendingData : completedData;
  // const tableData = status === "pending" ? pendingData : completedData;
  const tableColumns =
    status === "pending" ? pendingColumns : completedColumns;


  const getList = async (src, page) => {
    let res;
    try {
      setLoader(true);
      if (status === "pending") {
        res = await get(`${URLS.TRANSPORT_TRANSACTIONS_LIST}?search=${src}&page=${page}`);

      } else {
        res = await get(`${URLS.TRANSPORT_COMPLETED_LIST}?search=${src}&page=${page}`)
      }
      if (res?.status === "success") {
        setAdminList(res?.data);
        setTotalCount(res?.count);
      }
      console.log('res', res);
    }
    catch (err) {
      console.log('err', err);
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    const delay = setTimeout(() => {
      getList(search, pagination)

    }, 500)

    return () => clearTimeout(delay);

  }, [search, pagination, status])

  // ✅ RESET PAGE when searching
  useEffect(() => {
    setPagination(1);
  }, [search]);
  return (
    <div>
      <Header title={"Transaction Management"} />
      <div className="container-fluid main-container">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

          {/* LEFT TITLE */}
          <div>
            <h3 className="m-0 fw-bold fs-5 text-black">Transaction Management</h3>

            {/* ADD BUTTON */}

            <button
              onClick={() => setStatus("pending")}
              style={{ backgroundColor: status === "pending" ? "#F98425" : "" }}
              className={`btn fw-semibold px-4 py-2 mt-2 ${status === "pending" ? "text-white" : "border text-warning border-warning"}`}>
              Pending
            </button>
            <button
              onClick={() => setStatus("completed")}
              style={{ backgroundColor: status === "completed" ? "#F98425" : "" }}
              className={`btn  fw-semibold px-4 py-2 ms-4 mt-2 ${status === "completed" ? "text-white" : "border text-warning border-warning"}`}>
              Completed
            </button>
          </div>

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">

            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3">
              <input
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border-0 outline-none bg-transparent"
              />
              <div className="ms-2 searchdote" >|</div>
              <FaSearch color='#7A52AB' className="ms-1" />
            </div>



          </div>

        </div>
        <MaterialTable columns={tableColumns} data={adminList}
          rowCount={totalCount}
          pagination={pagination}
          setPagination={setPagination}
          loading={loader} />
      </div>
    </div>
  )
}

export default Transaction